import { render } from "./BaseDivider.vue?vue&type=template&id=10ec7b58&scoped=true"
import script from "./BaseDivider.vue?vue&type=script&lang=js"
export * from "./BaseDivider.vue?vue&type=script&lang=js"

import "./BaseDivider.vue?vue&type=style&index=0&id=10ec7b58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ec7b58"]])

export default __exports__